 const data=[
  {
    title:"待处理签约列表",
    entitle:"待处理签约列表",
    id:"0",
    icon:"iconfont icon-order-pending",
    children:[
      {
        title:"待处理签约列表",
        entitle:"待处理签约列表",
        id:"Pending",
        path:"/Pending?aid=Pending",
      }
    ]
  },
   {
     title:"签约列表",
     entitle:"签约列表",
     id:"3",
     icon:"iconfont icon-yichuligongdanshu",
     children:[
       {
         title:"签约列表",
         entitle:"签约列表",
         id:"ContractInfolist",
         path:"/ContractInfolist?aid=ContractInfolist",
       }
     ]
   },
   {
     title:"成为合作伙伴",
     entitle:"成为合作伙伴",
     id:"4",
     icon:"iconfont icon-tianjiadanju",
     children:[
       {
         title:"VAD合作伙伴",
         entitle:"VAD合作伙伴",
         id:"VAD",
         path:"/VAD?partnertype=VAD&aid=VAD",
       },
       {
         title:"金牌合作伙伴",
         entitle:"金牌合作伙伴",
         id:"goldpartner",
         path:"/goldpartner?partnertype=JP&aid=goldpartner",
       },
       {
         title:"认证合作伙伴",
         entitle:"认证合作伙伴",
         id:"certifiedpartner",
         path:"/certifiedpartner?partnertype=RZ&aid=certifiedpartner",
       },
       {
         title:"特许合作伙伴",
         entitle:"特许合作伙伴",
         id:"franchisedpartner",
         path:"/franchisedpartner?partnertype=TX&aid=franchisedpartner",
       },
       {
         title:"战略合作伙伴",
         entitle:"战略合作伙伴",
         id:"globalstrategicpartner",
         path:"/globalstrategicpartner?partnertype=ZL&aid=globalstrategicpartner",
       },
       {
         title:"注册伙伴",
         entitle:"注册合作伙伴",
         id:"registeredpartner",
         path:"/registeredpartner?partnertype=ZC&aid=registeredpartner",
       },
     ]
   }
];
 export default data;



// WEBPACK FOOTER //
// ./src/utils/menuData.js